<template>
  <span v-if="short">
    <span v-if="hours !== 0">{{ $n(hours) }} :</span>
    {{ $n(minutes) }}
    <span v-if="seconds !== 0 && !ignoreSeconds"> : {{ numberToString(seconds) }}</span>
  </span>
  <span v-else>
    {{ minutesInLongFormat }}
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    short: {
      type: Boolean,
      default: false
    },
    displayEmpty: {
      type: Boolean,
      default: false
    },
    ignoreSeconds: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hours () {
      return Math.floor(this.value / 60 / 60)
    },
    minutes () {
      return Math.floor((this.value / 60) - (this.hours * 60))
    },
    seconds () {
      return parseInt(this.value - (this.minutes * 60) - (this.hours * 60 * 60), 10)
    },
    timeArray () {
      const units = ['hour', 'minute', 'second']
      return [
        this.hours,
        this.minutes,
        this.ignoreSeconds ? 0 : this.seconds
      ]
        .map((value, i) => value ? i === 0 ? this.$n(value) : this.numberToString(value) : null)
        .map((value, i) => value ? { value, unit: units[i] } : { value: null })
        .filter(x => x.value)
    },
    minutesInLongFormat () {
      const times = this.timeArray
      return times
        .map((time, i) => {
          const sizeOfOne = times.length === 1
          const lastElement = i < times.length - 1
          const isSecond = time.unit === 'second'
          if (sizeOfOne || lastElement || isSecond) {
            return [time.value, this.$t(`formatters.minute.units.${time.unit}`)].join('')
          } else {
            return time.value
          }
        })
        .join(' ')
    }
  },
  methods: {
    numberToString (number) {
      return `0${number}`.substr(-2)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/formatters/Minute.vue